import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import blogs from '../../api/blogs'
import Athut from '../../images/blog/about-widget.jpg'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const BlogSidebar = (props) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [error, setError] = useState('');

    // Dynamic service links from your website
    const serviceLinks = [
        { name: "Air Freight", url: "/services/air-freight" },
        { name: "Sea Freight", url: "/services/sea-freight" },
        { name: "Road Freight", url: "/services/road-freight" },
        { name: "Management", url: "/services/management" },
        { name: "Customs Clearance", url: "/services/customs-clearance" },
        { name: "Project Logistics", url: "/services/project-logistics" },
        { name: "Heavy Lifts", url: "/services/heavy-lifts" },
        { name: "Cargo Insurance", url: "/services/cargo-insurance" },
        { name: "Removals & Relocation", url: "/services/removals-relocation" }
    ];

    const handleInputChange = (event) => {
        setSearchTerm(event.target.value);
        setError(''); 
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (searchTerm.trim() === '') {
            setError('Search term cannot be empty.');
            return;
        }
        // Add your search logic here
    };

    return (
        <div className={`col col-lg-4 col-12 ${props.blLeft}`}>
            <div className="blog-sidebar">
                {/* About Widget - remains same */}
                {/* <div className="widget about-widget d-none">
                    <div className="img-holder">
                        <img src={Athut} alt='' />
                    </div>
                    <h4>Rosalina D. Willaim</h4>
                    <span>Blogger/Photographer</span>
                    <p>he whimsically named Egg Canvas is the
                        design director and photographer
                        in New York. Why the nam</p>
                    <ul>
                        <li><Link onClick={ClickHandler} to="https://www.facebook.com/?_rdc=1&_rdr"><i className="flaticon-facebook-app-symbol"></i></Link></li>
                        <li><Link onClick={ClickHandler} to="https://in.linkedin.com/"><i className="flaticon-linkedin-big-logo"></i></Link></li>
                        <li><Link onClick={ClickHandler} to="https://youtube.com"><i className="fa-brands fa-youtube"></i></Link></li>
                        <li><Link onClick={ClickHandler} to="https://x.com/"><i className="flaticon-twitter"></i></Link></li>
                    </ul>
                </div> */}

                {/* Search Widget - remains same */}
                {/* <div className="widget search-widget d-none">
                    <h3>search here</h3>
                    <form onSubmit={handleSubmit}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search Post.."
                                value={searchTerm}
                                onChange={handleInputChange}
                                style={{ flexGrow: 1, borderColor: error ? 'red' : 'initial' }}
                            />
                            <button
                                type="submit"
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    padding: '0 10px',
                                    cursor: 'pointer',
                                }}
                            >
                                <i className="ti-search"></i>
                            </button>
                        </div>
                        {error && <p style={{ color: 'red', marginTop: '5px' }}>{error}</p>}
                    </form>
                </div> */}

                {/* Categories Widget - remains same */}
                <div className="widget category-widget">
                    <h3>Categories</h3>
                    <ul>
                        <li><Link onClick={ClickHandler} to="/blog/Why-Industry-Are-A-Juicy-Target-For-Cyberattack">Air Transport<span>03</span></Link></li>
                        <li><Link onClick={ClickHandler} to="/blog/Why-Industry-Are-A-Juicy-Target-For-Cyberattack" className="active">Road Transport <span>02</span></Link></li>
                        <li><Link onClick={ClickHandler} to="/blog/Why-Industry-Are-A-Juicy-Target-For-Cyberattack">Ocean Transport <span>04</span></Link></li>
                        <li><Link onClick={ClickHandler} to="/blog/Why-Industry-Are-A-Juicy-Target-For-Cyberattack">Land Transport <span>05</span></Link></li>
                    </ul>
                </div>

                {/* Recent Posts Widget - remains same */}
                <div className="widget recent-post-widget">
                    <h3>Related Posts</h3>
                    <div className="posts">
                        {blogs.slice(0, 3).map((bloge, indx) => (
                            <div className="post" key={indx}>
                                <div className="img-holder">
                                    <img src={bloge.SingleImg} alt='' />
                                </div>
                                <div className="details">
                                    <span className="date"><i className="flaticon-calendar"></i>{bloge.create_at}</span>
                                    <h4><Link onClick={ClickHandler} to={`/blog/${bloge.slug}`}>
                                        {bloge.title}</Link>
                                    </h4>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Popular Tags Widget - NOW DYNAMIC */}
                <div className="widget tag-widget">
                    <h3>Popular Tags</h3>
                    <ul>
                        {serviceLinks.map((service, index) => (
                            <li key={index}>
                                <Link 
                                    onClick={ClickHandler} 
                                    to={service.url}
                                >
                                    {service.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default BlogSidebar;